module.exports = __webpack_public_path__ + "assets/GoldPhi.88655eba8eded3615a3c6e35f70de961.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x-gold/GoldPhi.png
// module id = 770
// module chunks = 0